module.exports = __webpack_public_path__ + "media/icons/left-arrow-75ff1f7d.png";